/*
  File: assets/carakit-chemotherapy.js
  CaraKit Chemotherapy — Motion Theme
*/
(function () {
  'use strict';

  const VARIANT_MAP = Object.freeze({
    starter: '45858716909764',
    small: '41192639234244',
    medium: '40833481474244',
    large: '40833494646980'
  });

  const ALLOWED_SIZES = ['starter', 'small', 'medium', 'large'];

  function escapeHtml(value) {
    return String(value == null ? '' : value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }

  function money(value) {
    return '$' + Number(value || 0).toFixed(2);
  }

  var GiftOrder = window.CaraKitOrderGift || (window.CaraKitOrderGift = (function () {
    var applying = false;
    var timer = null;
    var state = {
      isGift: false,
      isCompany: false,
      to: '',
      from: '',
      company: '',
      dept: '',
      message: '',
      sendDelivery: false,
      email: ''
    };

    function emptyAttrs() {
      return {
        'Is Gift': '',
        'Gift Type': '',
        'Company Name': '',
        'Department': '',
        'From': '',
        'To': '',
        'Gift Message': '',
        'Send Delivery Email': '',
        'Recipient Email': ''
      };
    }

    function toAttributes() {
      var attrs = emptyAttrs();
      if (!state.isGift) return attrs;
      attrs['Is Gift'] = 'Yes';
      attrs['Gift Type'] = state.isCompany ? 'Company Gift' : 'Personal Gift';
      attrs['To'] = state.to;
      attrs['Gift Message'] = state.message;
      if (state.isCompany) {
        attrs['Company Name'] = state.company;
        attrs['Department'] = state.dept;
      } else {
        attrs['From'] = state.from;
      }
      if (state.sendDelivery) {
        attrs['Send Delivery Email'] = 'Yes';
        attrs['Recipient Email'] = state.email;
      }
      return attrs;
    }

    function toNote() {
      if (!state.isGift) return '';
      var parts = [];
      if (state.to) parts.push('To: ' + state.to);
      if (state.isCompany) {
        if (state.company) parts.push('From: ' + state.company);
        if (state.dept) parts.push('Dept: ' + state.dept);
      } else if (state.from) {
        parts.push('From: ' + state.from);
      }
      if (state.message) parts.push(state.message);
      if (state.sendDelivery && state.email) parts.push('Delivery note: ' + state.email);
      return parts.join('\n');
    }

    function setVal(el, value) {
      if (!el) return;
      if (el.type === 'checkbox') {
        el.checked = !!value;
      } else if (el.value !== String(value || '')) {
        el.value = value || '';
      }
    }

    function applyProduct() {
      document.querySelectorAll('.carakit-chemo__gift-box').forEach(function (box) {
        var gift = box.querySelector('[id^="CarakitGift-"]');
        var company = box.querySelector('[data-gift-company]');
        var fields = box.querySelector('[id^="CarakitGiftFields-"]');
        var fromWrap = box.querySelector('[id^="CarakitStandardFrom-"]');
        var companyWrap = box.querySelector('[id^="CarakitCompanyFields-"]');
        var count = box.querySelector('[id^="CarakitGiftWordCount-"]');
        setVal(gift, state.isGift);
        setVal(company, state.isCompany);
        setVal(box.querySelector('[data-gift-recipient]'), state.to);
        setVal(box.querySelector('[data-gift-from]'), state.from);
        setVal(box.querySelector('[data-gift-company-name]'), state.company);
        setVal(box.querySelector('[data-gift-department]'), state.dept);
        setVal(box.querySelector('[data-gift-message]'), state.message);
        setVal(box.querySelector('[data-gift-encouragement]'), state.sendDelivery);
        setVal(box.querySelector('[data-gift-email]'), state.email);
        if (fields) fields.style.display = state.isGift ? 'block' : 'none';
        if (fromWrap) fromWrap.style.display = state.isCompany ? 'none' : 'block';
        if (companyWrap) companyWrap.style.display = state.isCompany ? 'block' : 'none';
        if (count) {
          var words = state.message.trim() ? state.message.trim().split(/\s+/).length : 0;
          count.textContent = words + '/150 words';
        }
      });
    }

    function applyDrawer() {
      var toggle = document.getElementById('ckGiftToggle');
      var company = document.getElementById('ckCompanyGift');
      var body = document.querySelector('#CartDrawer .ck-gift-body');
      var count = document.getElementById('ckGiftWords');
      var note = document.getElementById('CartNoteDrawer');
      if (toggle) {
        toggle.classList.toggle('is-on', state.isGift);
        toggle.setAttribute('aria-pressed', state.isGift ? 'true' : 'false');
      }
      setVal(company, state.isCompany);
      if (body) body.classList.toggle('is-company', state.isCompany);
      setVal(document.getElementById('ckGiftTo'), state.to);
      setVal(document.getElementById('ckGiftFrom'), state.from);
      setVal(document.getElementById('ckGiftCompany'), state.company);
      setVal(document.getElementById('ckGiftDept'), state.dept);
      setVal(document.getElementById('ckGiftMessage'), state.message);
      setVal(document.getElementById('ckDeliveryNote'), state.sendDelivery);
      setVal(document.getElementById('ckGiftEmail'), state.email);
      if (count) {
        var words = state.message.trim() ? state.message.trim().split(/\s+/).length : 0;
        count.textContent = words + '/150 words';
      }
      if (note) note.value = toNote();
    }

    function applyAll() {
      applying = true;
      applyProduct();
      applyDrawer();
      applying = false;
    }

    function readProduct(box) {
      if (!box) return;
      var gift = box.querySelector('[id^="CarakitGift-"]');
      var company = box.querySelector('[data-gift-company]');
      var to = box.querySelector('[data-gift-recipient]');
      var from = box.querySelector('[data-gift-from]');
      var companyName = box.querySelector('[data-gift-company-name]');
      var dept = box.querySelector('[data-gift-department]');
      var message = box.querySelector('[data-gift-message]');
      var send = box.querySelector('[data-gift-encouragement]');
      var email = box.querySelector('[data-gift-email]');
      state.isGift = !!(gift && gift.checked);
      state.isCompany = !!(company && company.checked);
      state.to = to ? to.value : '';
      state.from = from ? from.value : '';
      state.company = companyName ? companyName.value : '';
      state.dept = dept ? dept.value : '';
      state.message = message ? message.value : '';
      state.sendDelivery = !!(send && send.checked);
      state.email = email ? email.value : state.email;
    }

    function readDrawer() {
      var toggle = document.getElementById('ckGiftToggle');
      if (!toggle && !document.getElementById('ckGiftTo')) return;
      state.isGift = !!(toggle && toggle.classList.contains('is-on'));
      var company = document.getElementById('ckCompanyGift');
      var to = document.getElementById('ckGiftTo');
      var from = document.getElementById('ckGiftFrom');
      var companyName = document.getElementById('ckGiftCompany');
      var dept = document.getElementById('ckGiftDept');
      var message = document.getElementById('ckGiftMessage');
      var send = document.getElementById('ckDeliveryNote');
      var email = document.getElementById('ckGiftEmail');
      state.isCompany = !!(company && company.checked);
      state.to = to ? to.value : '';
      state.from = from ? from.value : '';
      state.company = companyName ? companyName.value : '';
      state.dept = dept ? dept.value : '';
      state.message = message ? message.value : '';
      state.sendDelivery = !!(send && send.checked);
      state.email = email ? email.value : '';
    }

    function save() {
      return fetch('/cart/update.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ attributes: toAttributes(), note: toNote() })
      }).catch(function () {});
    }

    function queueSave() {
      clearTimeout(timer);
      timer = setTimeout(save, 400);
    }

    function isGiftToggleEl(el) {
      if (!el) return false;
      if (el.id === 'ckGiftToggle') return true;
      if (el.matches && el.matches('[id^="CarakitGift-"]')) return true;
      return !!(el.id && el.id.indexOf('CarakitGift-') === 0);
    }

    function changedFrom(source, event) {
      if (applying) return;
      if (source === 'drawer') readDrawer();
      else readProduct(source);
      var target = event && event.target;
      if (!isGiftToggleEl(target) && !state.isGift && (state.to || state.from || state.company || state.message || state.email)) {
        state.isGift = true;
      }
      applyAll();
      queueSave();
    }

    function bindProduct(box) {
      if (!box || box.getAttribute('data-ck-gift-bound')) return;
      box.setAttribute('data-ck-gift-bound', '1');
      box.addEventListener('input', function (event) { changedFrom(box, event); });
      box.addEventListener('change', function (event) { changedFrom(box, event); });
    }

    function bindDrawer() {
      var ids = ['ckGiftToggle', 'ckCompanyGift', 'ckGiftTo', 'ckGiftFrom', 'ckGiftCompany', 'ckGiftDept', 'ckGiftMessage', 'ckDeliveryNote', 'ckGiftEmail'];
      ids.forEach(function (id) {
        var el = document.getElementById(id);
        if (!el || el.getAttribute('data-ck-order-gift')) return;
        el.setAttribute('data-ck-order-gift', '1');
        el.addEventListener(id === 'ckGiftToggle' ? 'click' : 'input', function (event) {
          setTimeout(function () { changedFrom('drawer', event); }, 0);
        });
        el.addEventListener('change', function (event) { changedFrom('drawer', event); });
      });
    }

    function loadFromCart() {
      return fetch('/cart.js', { credentials: 'same-origin' })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var a = cart.attributes || {};
          state.isGift = a['Is Gift'] === 'Yes';
          state.isCompany = a['Gift Type'] === 'Company Gift';
          state.to = a['To'] || '';
          state.from = a['From'] || '';
          state.company = a['Company Name'] || '';
          state.dept = a['Department'] || '';
          state.message = a['Gift Message'] || '';
          state.sendDelivery = a['Send Delivery Email'] === 'Yes';
          state.email = a['Recipient Email'] || '';
          applyAll();
        })
        .catch(function () {});
    }

    function init() {
      document.querySelectorAll('.carakit-chemo__gift-box').forEach(bindProduct);
      bindDrawer();
      loadFromCart();
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }

    return {
      save: save,
      apply: applyAll,
      state: state
    };
  })());

  function getItemIcon(itemName) {
    const name = String(itemName || '').toLowerCase();

    const icons = {
      droplets: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M7 16.3c2.2 0 4-1.83 4-4.05 0-1.16-.57-2.26-1.71-3.19S7.29 6.75 7 5.3c-.29 1.45-1.14 2.84-2.29 3.76S3 11.1 3 12.25c0 2.22 1.8 4.05 4 4.05z"/><path d="M12.56 6.6A10.97 10.97 0 0 0 14 3.02c.5 2.5 2 4.9 4 6.5s3 3.5 3 5.5a6.98 6.98 0 0 1-11.91 4.97"/></svg>',
      sofa: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M20 9V6a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2v3"/><path d="M2 16a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-5a2 2 0 0 0-4 0v1.5a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5V11a2 2 0 0 0-4 0z"/><path d="M4 18v2"/><path d="M20 18v2"/><path d="M12 4v9"/></svg>',
      pillBottle: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M18 11h-4a1 1 0 0 0-1 1v5a1 1 0 0 0 1 1h4"/><path d="M6 7v13a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V7"/><rect width="16" height="5" x="4" y="2" rx="1"/></svg>',
      bookText: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M4 19.5v-15A2.5 2.5 0 0 1 6.5 2H19a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1H6.5a1 1 0 0 1 0-5H20"/><path d="M8 11h8"/><path d="M8 7h6"/></svg>',
      candy: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="m9.5 7.5-2 2a4.95 4.95 0 1 0 7 7l2-2a4.95 4.95 0 1 0-7-7Z"/><path d="M14 6.5v10"/><path d="M10 7.5v10"/><path d="m16 7 1-5 1.37.68A3 3 0 0 0 19.7 3H21v1.3c0 .46.1.92.32 1.33L22 7l-5 1"/><path d="m8 17-1 5-1.37-.68A3 3 0 0 0 4.3 21H3v-1.3a3 3 0 0 0-.32-1.33L2 17l5-1"/></svg>',
      glassWater: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M5.116 4.104A1 1 0 0 1 6.11 3h11.78a1 1 0 0 1 .994 1.105L17.19 20.21A2 2 0 0 1 15.2 22H8.8a2 2 0 0 1-2-1.79z"/><path d="M6 12a5 5 0 0 1 6 0 5 5 0 0 0 6 0"/></svg>',
      leaf: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M11 20A7 7 0 0 1 9.8 6.1C15.5 5 17 4.48 19 2c1 2 2 4.18 2 8 0 5.5-4.78 10-10 10Z"/><path d="M2 21c0-3 1.85-5.36 5.08-6C9.5 14.52 12 13 13 12"/></svg>',
      bath: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M10 4 8 6"/><path d="M17 19v2"/><path d="M2 12h20"/><path d="M7 19v2"/><path d="M9 5 7.621 3.621A2.121 2.121 0 0 0 4 5v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-5"/></svg>',
      pipette: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="m2 22 1-1h3l9-9"/><path d="M3 21v-3l9-9"/><path d="m15 6 3.4-3.4a2.1 2.1 0 1 1 3 3L18 9l.4.4a2.1 2.1 0 1 1-3 3l-3.8-3.8a2.1 2.1 0 1 1 3-3l.4.4Z"/></svg>',
      shirt: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M20.38 3.46 16 2a4 4 0 0 1-8 0L3.62 3.46a2 2 0 0 0-1.34 2.23l.58 3.47a1 1 0 0 0 .99.84H6v10c0 1.1.9 2 2 2h8a2 2 0 0 0 2-2V10h2.15a1 1 0 0 0 .99-.84l.58-3.47a2 2 0 0 0-1.34-2.23z"/></svg>',
      crown: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M11.562 3.266a.5.5 0 0 1 .876 0L15.39 8.87a1 1 0 0 0 1.516.294L21.183 5.5a.5.5 0 0 1 .798.519l-2.834 10.246a1 1 0 0 1-.956.734H5.81a1 1 0 0 1-.957-.734L2.02 6.02a.5.5 0 0 1 .798-.519l4.276 3.664a1 1 0 0 0 1.516-.294z"/><path d="M5 21h14"/></svg>',
      thermometer: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M14 4v10.54a4 4 0 1 1-4 0V4a2 2 0 0 1 4 0Z"/></svg>',
      shoppingBag: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M6 2 3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4Z"/><path d="M3 6h18"/><path d="M16 10a4 4 0 0 1-8 0"/></svg>',
      eye: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M2.062 12.348a1 1 0 0 1 0-.696 10.75 10.75 0 0 1 19.876 0 1 1 0 0 1 0 .696 10.75 10.75 0 0 1-19.876 0"/><circle cx="12" cy="12" r="3"/></svg>',
      heart: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M19 14c1.49-1.46 3-3.21 3-5.5A5.5 5.5 0 0 0 16.5 3c-1.76 0-3 .5-4.5 2-1.5-1.5-2.74-2-4.5-2A5.5 5.5 0 0 0 2 8.5c0 2.3 1.5 4.05 3 5.5l7 7Z"/></svg>',
      coffee: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M10 2v2"/><path d="M14 2v2"/><path d="M16 8a1 1 0 0 1 1 1v8a4 4 0 0 1-4 4H7a4 4 0 0 1-4-4V9a1 1 0 0 1 1-1h14a4 4 0 1 1 0 8h-1"/><path d="M6 2v2"/></svg>',
      flame: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M8.5 14.5A2.5 2.5 0 0 0 11 12c0-1.38-.5-2-1-3-1.072-2.143-.224-4.054 2-6 .5 2.5 2 4.9 4 6.5 2 1.6 3 3.5 3 5.5a7 7 0 1 1-14 0c0-1.153.433-2.294 1-3a2.5 2.5 0 0 0 2.5 2.5z"/></svg>',
      package: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M11 21.73a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73z"/><path d="M12 22V12"/><path d="m3.3 7 7.703 4.734a2 2 0 0 0 1.994 0L20.7 7"/><path d="m7.5 4.27 9 5.15"/></svg>',
      footprints: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M4 16v-2.38C4 11.5 2.97 10.5 3 8c.03-2.72 1.49-6 4.5-6C9.37 2 10 3.8 10 5.5c0 3.11-2 5.66-2 8.68V16a2 2 0 1 1-4 0Z"/><path d="M20 20v-2.38c0-2.12 1.03-3.12 1-5.62-.03-2.72-1.49-6-4.5-6C14.63 6 14 7.8 14 9.5c0 3.11 2 5.66 2 8.68V20a2 2 0 1 0 4 0Z"/><path d="M16 17h4"/><path d="M4 13h4"/></svg>',
      lollipop: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="11" cy="11" r="8"/><path d="m21 21-4.3-4.3"/><path d="M11 11a2 2 0 0 0 4 0 4 4 0 0 0-8 0 6 6 0 0 0 12 0"/></svg>',
      moon: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M12 3a6 6 0 0 0 9 9 9 9 0 1 1-9-9Z"/></svg>',
      layers: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="m12.83 2.18a2 2 0 0 0-1.66 0L2.6 6.08a1 1 0 0 0 0 1.83l8.58 3.91a2 2 0 0 0 1.66 0l8.58-3.9a1 1 0 0 0 0-1.83Z"/><path d="m22 17.65-9.17 4.16a2 2 0 0 1-1.66 0L2 17.65"/><path d="m22 12.65-9.17 4.16a2 2 0 0 1-1.66 0L2 12.65"/></svg>',
      puzzle: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M15.39 4.39a1 1 0 0 0 1.68-.474 2.5 2.5 0 1 1 3.014 3.015 1 1 0 0 0-.474 1.68l1.683 1.682a2.414 2.414 0 0 1 0 3.414L19.61 15.39a1 1 0 0 1-1.68-.474 2.5 2.5 0 1 0-3.014 3.015 1 1 0 0 1 .474 1.68l-1.683 1.682a2.414 2.414 0 0 1-3.414 0L8.61 19.61a1 1 0 0 0-1.68.474 2.5 2.5 0 1 1-3.014-3.015 1 1 0 0 0 .474-1.68l-1.683-1.682a2.414 2.414 0 0 1 0-3.414L4.39 8.61a1 1 0 0 1 1.68.474 2.5 2.5 0 1 0 3.014-3.015 1 1 0 0 1-.474-1.68l1.683-1.682a2.414 2.414 0 0 1 3.414 0z"/></svg>',
      sparkles: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M9.937 15.5A2 2 0 0 0 8.5 14.063l-6.135-1.582a.5.5 0 0 1 0-.962L8.5 9.936A2 2 0 0 0 9.937 8.5l1.582-6.135a.5.5 0 0 1 .963 0L14.063 8.5A2 2 0 0 0 15.5 9.937l6.135 1.581a.5.5 0 0 1 0 .964L15.5 14.063a2 2 0 0 0-1.437 1.437l-1.582 6.135a.5.5 0 0 1-.963 0z"/><path d="M20 3v4"/><path d="M22 5h-4"/><path d="M4 17v2"/><path d="M5 18H3"/></svg>',
      dumbbell: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M14.4 14.4 9.6 9.6"/><path d="M18.657 21.485a2 2 0 1 1-2.829-2.828l-1.767 1.768a2 2 0 1 1-2.829-2.829l6.364-6.364a2 2 0 1 1 2.829 2.829l-1.768 1.767a2 2 0 1 1 2.828 2.829z"/><path d="m21.5 21.5-1.4-1.4"/><path d="M3.9 3.9 2.5 2.5"/><path d="M6.404 12.768a2 2 0 1 1-2.829-2.829l1.768-1.767a2 2 0 1 1-2.828-2.829l2.828-2.828a2 2 0 1 1 2.829 2.828l1.767-1.768a2 2 0 1 1 2.829 2.829z"/></svg>',
      snowflake: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="2" x2="22" y1="12" y2="12"/><line x1="12" x2="12" y1="2" y2="22"/><path d="m20 16-4-4 4-4"/><path d="m4 8 4 4-4 4"/><path d="m16 4-4 4-4-4"/><path d="m8 20 4-4 4 4"/></svg>',
      showerHead: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="m4 4 2.5 2.5"/><path d="M13.5 6.5a4.95 4.95 0 0 0-7 7"/><path d="M15 5 5 15"/><path d="M14 17v.01"/><path d="M10 16v.01"/><path d="M13 13v.01"/><path d="M16 10v.01"/><path d="M11 20v.01"/><path d="M17 14v.01"/><path d="M20 11v.01"/></svg>',
      hand: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M18 11V6a2 2 0 0 0-2-2a2 2 0 0 0-2 2"/><path d="M14 10V4a2 2 0 0 0-2-2a2 2 0 0 0-2 2v2"/><path d="M10 10.5V6a2 2 0 0 0-2-2a2 2 0 0 0-2 2v8"/><path d="M18 8a2 2 0 1 1 4 0v6a8 8 0 0 1-8 8h-2c-2.8 0-4.5-.86-5.99-2.34l-3.6-3.6a2 2 0 0 1 2.83-2.82L7 15"/></svg>',
      brain: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M12 5a3 3 0 1 0-5.997.125 4 4 0 0 0-2.526 5.77 4 4 0 0 0 .556 6.588A4 4 0 1 0 12 18Z"/><path d="M12 5a3 3 0 1 1 5.997.125 4 4 0 0 1 2.526 5.77 4 4 0 0 1-.556 6.588A4 4 0 1 1 12 18Z"/><path d="M15 13a4.5 4.5 0 0 1-3-4 4.5 4.5 0 0 1-3 4"/><path d="M17.599 6.5a3 3 0 0 0 .399-1.375"/><path d="M6.003 5.125A3 3 0 0 0 6.401 6.5"/><path d="M3.477 10.896a4 4 0 0 1 .585-.396"/><path d="M19.938 10.5a4 4 0 0 1 .585.396"/><path d="M6 18a4 4 0 0 1-1.967-.516"/><path d="M19.967 17.484A4 4 0 0 1 18 18"/></svg>',
      lightbulb: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M15 14c.2-1 .7-1.7 1.5-2.5 1-.9 1.5-2.2 1.5-3.5A6 6 0 0 0 6 8c0 1 .2 2.2 1.5 3.5.7.7 1.3 1.5 1.5 2.5"/><path d="M9 18h6"/><path d="M10 22h4"/></svg>',
      fileText: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z"/><path d="M14 2v4a2 2 0 0 0 2 2h4"/><path d="M10 9H8"/><path d="M16 13H8"/><path d="M16 17H8"/></svg>',
      bed: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M2 4v16"/><path d="M2 8h18a2 2 0 0 1 2 2v10"/><path d="M2 17h20"/><path d="M6 8v9"/></svg>'
    };

    if (name.includes('moisturizer') || name.includes('lotion') || name.includes('hand cream') || name.includes('face mist') || name.includes('body lotion') || name.includes('dry mouth rinse')) return icons.droplets;
    if (name.includes('shawl')) return icons.sofa;
    if (name.includes('lip balm') || name.includes('lipbalm')) return icons.pillBottle;
    if (name.includes('journal') || name.includes('planner') || name.includes('note to self') || name.includes('heart talk') || name.includes('brain book')) {
      if (name.includes('brain')) return icons.brain;
      return icons.bookText;
    }
    if (name.includes('lollipop')) return icons.lollipop;
    if (name.includes('caramel') || name.includes('chocolate') || name.includes('candy')) return icons.candy;
    if (name.includes('hydration') || name.includes('electrolyte') || name.includes('water bottle')) return icons.glassWater;
    if (name.includes('essential oil roller') || name.includes('roll-on') || (name.includes('roller') && name.includes('oil')) || name.includes('anti-nausea aromatherapy')) return icons.pipette;
    if (name.includes('epsom') || name.includes('bath soak') || name.includes('muscle soak') || name.includes('waxelene ointment')) return icons.bath;
    if (name.includes('vitamin e') || name.includes('aloe') || name.includes('calendula') || name.includes('arnica') || name.includes('ginger') || name.includes('almond') || name.includes('essential oil') || name.includes('essential oils') || name.includes('homme')) return icons.leaf;
    if (name.includes('tea') || name.includes('mug') || name.includes('strainer')) return icons.coffee;
    if (name.includes('soft comfort socks') || name.includes('footprint')) return icons.footprints;
    if (name.includes('socks')) return icons.shirt;
    if (name.includes('beanie') || name.includes('headcover')) return icons.crown;
    if (name.includes('heating') || name.includes('thermometer')) return icons.thermometer;
    if (name.includes('tote') || name.includes('bag')) return icons.shoppingBag;
    if (name.includes('eye drops') || name.includes('eye drop')) return icons.eye;
    if (name.includes('heart')) return icons.heart;
    if (name.includes('smudge')) return icons.flame;
    if (name.includes('lint')) return icons.package;
    if (name.includes('eye mask') || name.includes('sleep spray')) return icons.moon;
    if (name.includes('blanket') || name.includes('weighted') || name.includes('comfort wrap')) return icons.layers;
    if (name.includes('puzzle')) return icons.puzzle;
    if (name.includes('bracelet')) return icons.sparkles;
    if (name.includes('exercise') || name.includes('band')) return icons.dumbbell;
    if (name.includes('ice pack')) return icons.snowflake;
    if (name.includes('shower') || name.includes('shampoo')) return icons.showerHead;
    if (name.includes('scratcher')) return icons.hand;
    if (name.includes('mind delight')) return icons.lightbulb;
    if (name.includes('gathered')) return icons.fileText;
    if (name.includes('pillow')) return icons.bed;
    if (name.includes('oil') || name.includes('salt')) return icons.leaf;
    if (name.includes('drops')) return icons.glassWater;

    return icons.droplets;
  }

  function getShopifyRoot() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  function openCartDrawer() {
    if (window.CaraKitOpenCartDrawer) {
      window.CaraKitOpenCartDrawer();
      return;
    }
    document.dispatchEvent(new CustomEvent('cart:open', { bubbles: true }));
    document.dispatchEvent(new CustomEvent('cart:build', { bubbles: true }));
    var safe = document.querySelector('.js-drawer-open-cart, [aria-controls="CartDrawer"]');
    if (safe && safe.getAttribute('href') !== '/cart' && safe.getAttribute('href') !== '/cart/') {
      try { safe.click(); } catch (e) {}
    }
  }

  function updateUrl(size) {
    const url = new URL(window.location.href);
    url.searchParams.set('size', size);
    window.history.replaceState({}, '', url.toString());
  }

  function boot(sectionId) {
    const root = document.getElementById('CaraKitChemotherapy-' + sectionId);
    const cfg = window.CaraKitChemotherapy && window.CaraKitChemotherapy[sectionId];

    if (!root || !cfg) return;

    const query = (selector) => root.querySelector(selector);

    const mainImage = query('#CarakitMainImage-' + sectionId);
    const thumbs = query('#CarakitThumbs-' + sectionId);
    const sizeCards = query('#CarakitSizeCards-' + sectionId);
    const priceEl = query('#CarakitPrice-' + sectionId);
    const shortEl = query('#CarakitShortDescription-' + sectionId);
    const qtyEl = query('#CarakitQuantity-' + sectionId);
    const addBtn = query('#CarakitAddToCart-' + sectionId);
    const whyEl = query('#CarakitWhy-' + sectionId);
    const itemsEl = query('#CarakitWhatsInside-' + sectionId);
    const comparisonEl = query('#CarakitComparison-' + sectionId);
    const exclusiveEl = query('#CarakitExclusive-' + sectionId);
    const whyChooseEl = query('#CarakitWhyChoose-' + sectionId);
    const instructionEl = query('#CarakitInstruction-' + sectionId);
    const instructionWrap = query('#CarakitInstructionWrap-' + sectionId);
    
    // Gift Elements
    const giftToggle = query('#CarakitGift-' + sectionId);
    const giftFields = query('#CarakitGiftFields-' + sectionId);
    const companyToggle = query('#CarakitCompanyToggle-' + sectionId);
    const standardFromBlock = query('#CarakitStandardFrom-' + sectionId);
    const companyFieldsBlock = query('#CarakitCompanyFields-' + sectionId);
    const giftMessageArea = query('[data-gift-message]');
    const giftWordCount = query('#CarakitGiftWordCount-' + sectionId);

    const buildOnBtn = query('#CarakitBuildOn-' + sectionId);
    const personalizeBtn = query('#CarakitPersonalize-' + sectionId);
    const selectedNameEl = query('#CarakitSelectedName-' + sectionId);
    const selectedCountEl = query('#CarakitSelectedCount-' + sectionId);
    const accordionButton = query('[data-accordion="whats-inside"]');

    let params = new URLSearchParams(window.location.search);
    let selected = params.get('size');
    if (!ALLOWED_SIZES.includes(selected)) selected = 'medium';

    let quantity = 1;
    let galleryIndex = 0;
    let expanded = true;
    let booting = false;

    function selectedData() {
      return cfg.sizes[selected];
    }

    function findVariant(size) {
      if (cfg.variants && cfg.variants[size]) return cfg.variants[size];
      return VARIANT_MAP[size] || null;
    }

    function syncQuantityUI() {
      if (qtyEl) qtyEl.textContent = String(quantity);
    }

    function renderSizeCards() {
      if (!sizeCards) return;

      const cards = [
        ['starter', 'Starter', ''],
        ['small', 'Small', ''],
        ['medium', 'Medium', ''],
        ['large', 'Large', '']
      ];

      sizeCards.innerHTML = cards.map(function (card) {
        const key = card[0];
        const data = cfg.sizes[key];
        const active = selected === key;

        return '' +
          '<button type="button" class="carakit-chemo__size-card ' + (active ? 'is-active' : '') + '" data-size="' + key + '">' +
            (active ? '<span class="pill">' + escapeHtml(card[2]) + '</span>' : '') +
            '<h3>' + escapeHtml(card[1]) + '</h3>' +
            '<div class="price">' + escapeHtml(data.priceText) + '</div>' +
            '<div class="meta">' + escapeHtml(data.itemsCount) + ' items</div>' +
          '</button>';
      }).join('');

      sizeCards.querySelectorAll('[data-size]').forEach(function (button) {
        button.addEventListener('click', function () {
          setSize(button.dataset.size, true);
        });
      });
    }

    function renderGallery(data) {
      if (!mainImage || !thumbs) return;

      let gallery = [];
      if (data.variantImage) gallery.push(data.variantImage);
      if (Array.isArray(data.gallery)) gallery = gallery.concat(data.gallery.filter(Boolean));
      gallery = gallery.filter(function (src, index, arr) {
        return arr.indexOf(src) === index;
      });

      if (!gallery.length) {
        mainImage.removeAttribute('src');
        mainImage.alt = 'Chemotherapy Care Kit - ' + data.name;
        thumbs.innerHTML = '';
        thumbs.hidden = true;
        return;
      }

      galleryIndex = Math.min(galleryIndex, gallery.length - 1);
      mainImage.src = gallery[galleryIndex];
      mainImage.alt = 'Chemotherapy Care Kit - ' + data.name;
      thumbs.hidden = gallery.length < 2;

      thumbs.innerHTML = gallery.map(function (src, index) {
        return '<button type="button" class="carakit-chemo__thumb ' +
          (index === galleryIndex ? 'is-active' : '') +
          '" data-gallery-index="' + index + '" aria-label="View image ' + (index + 1) + '">' +
            '<img src="' + escapeHtml(src) + '" alt="' + escapeHtml(data.name) + ' view ' + (index + 1) + '" loading="lazy">' +
          '</button>';
      }).join('');

      thumbs.querySelectorAll('[data-gallery-index]').forEach(function (button) {
        button.addEventListener('click', function () {
          galleryIndex = Number(button.dataset.galleryIndex) || 0;
          renderGallery(data);
        });
      });
    }

    function renderItems(data) {
      if (!itemsEl) return;

      itemsEl.style.display = expanded ? 'grid' : 'none';

      itemsEl.innerHTML = (data.items || []).map(function (item) {
        const iconSvg = getItemIcon(item[0]);
        return '' +
          '<article class="carakit-chemo__item">' +
            '<div class="carakit-chemo__item-icon-wrap">' + iconSvg + '</div>' +
            '<div>' +
              '<strong>' + escapeHtml(item[0]) + '</strong>' +
              '<p>' + escapeHtml(item[1]) + '</p>' +
            '</div>' +
          '</article>';
      }).join('');

      if (accordionButton) {
        accordionButton.setAttribute('aria-expanded', expanded ? 'true' : 'false');
        const iconEl = accordionButton.querySelector('.carakit-chemo__accordion-icon');
        if (iconEl) iconEl.textContent = expanded ? '✕' : '+';
      }
    }

    function renderComparison() {
      if (!comparisonEl) return;

      const cards = [
        ['starter', 'Starter Box', ['Practical treatment-day essentials', 'Hydration & nausea relief', 'A meaningful first step of care']],
        ['small', 'Small Box', ['Thoughtful comfort essentials', 'Emotional support basics', 'Ideal for encouragement and early care']],
        ['medium', 'Medium Box', ['Everything in Small', 'Expanded comfort + care items', 'Designed for ongoing treatment support']],
        ['large', 'Large Box', ['Everything in Small + Medium', 'Complete, head-to-toe chemo support', 'Designed to carry someone through treatment']]
      ];

      comparisonEl.innerHTML = cards.map(function (card) {
        const key = card[0];
        const data = cfg.sizes[key];
        const active = selected === key;

        return '' +
          '<button type="button" class="carakit-chemo__comparison-card ' + (active ? 'is-active' : '') + '" data-size="' + key + '">' +
            (active ? '<span class="comparison-pill">' + escapeHtml(data.label) + '</span>' : '') +
            '<h3>' + escapeHtml(card[1]) + '</h3>' +
            (key === 'large' ? '<p class="comparison-emphasis">Complete Chemo Support</p>' : '') +
            '<ul>' + card[2].map(function (line) { return '<li>' + escapeHtml(line) + '</li>'; }).join('') + '</ul>' +
            '<div class="carakit-chemo__comparison-price">' +
              escapeHtml(data.priceText) + ' <small>' + escapeHtml(data.itemsCount) + ' items</small>' +
            '</div>' +
          '</button>';
      }).join('');

      comparisonEl.querySelectorAll('[data-size]').forEach(function (button) {
        button.addEventListener('click', function () {
          setSize(button.dataset.size, false);
        });
      });
    }

    function renderExclusive(data) {
      if (!exclusiveEl) return;

      const groups = data.exclusiveGroups || [];

      exclusiveEl.innerHTML = '' +
        '<div class="carakit-chemo__exclusive-box">' +
          '<h3>' + escapeHtml(data.exclusiveTitle) + '</h3>' +
          '<p>' + escapeHtml(data.exclusiveSubtitle) + '</p>' +
          '<div class="carakit-chemo__exclusive-grid">' +
            groups.map(function (group) {
              return '' +
                '<div class="carakit-chemo__exclusive-group">' +
                  '<h4>' + escapeHtml(group[0]) + '</h4>' +
                  '<ul>' + group[1].map(function (item) { return '<li>✓ ' + escapeHtml(item) + '</li>'; }).join('') + '</ul>' +
                '</div>';
            }).join('') +
          '</div>' +
        '</div>';
    }

    function renderWhyChoose(data) {
      if (!whyChooseEl) return;

      whyChooseEl.innerHTML = '' +
        '<div class="carakit-chemo__why-choose">' +
          '<h4>' + escapeHtml(data.whyChooseTitle) + '</h4>' +
          '<p>' + escapeHtml(data.whyChoose) + '</p>' +
          '<p class="best-for"><strong>Best for:</strong> ' + escapeHtml(data.bestFor) + '</p>' +
        '</div>';
    }

    function renderInstruction(data) {
      if (!instructionEl || !instructionWrap) return;

      if (data.instruction) {
        instructionEl.src = data.instruction;
        instructionEl.alt = 'CaraKit Chemotherapy Care Kit ' + data.name + ' instruction card showing product guidance';
        instructionWrap.hidden = false;
      } else {
        instructionEl.removeAttribute('src');
        instructionWrap.hidden = true;
      }
    }

    function renderMainData(data) {
      if (priceEl) priceEl.textContent = data.priceText;
      if (shortEl) shortEl.textContent = data.short;
      if (whyEl) whyEl.textContent = data.why;
      if (selectedNameEl) selectedNameEl.textContent = data.name;
      if (selectedCountEl) selectedCountEl.textContent = data.itemsCount + ' items';

      if (addBtn) {
        addBtn.textContent = 'Add to Cart — ' + money(data.price * quantity);
        addBtn.dataset.size = selected;
      }

      if (buildOnBtn) {
        const base = cfg.buildOnUrl || '/pages/build-your-own';
        const url = new URL(base, window.location.origin);
        url.searchParams.set('size', selected);
        url.searchParams.set('qty', quantity);
        buildOnBtn.href = url.pathname + url.search;
        if (personalizeBtn) personalizeBtn.href = url.pathname + url.search;
      }
    }

    function setSize(size, shouldScroll) {
      if (!ALLOWED_SIZES.includes(size)) return;
      selected = size;
      galleryIndex = 0;
      updateUrl(selected);
      render();

      if (shouldScroll) {
        window.scrollTo({
          top: Math.max(0, root.offsetTop - 70),
          behavior: 'smooth'
        });
      }
    }

    function getProperties(data) {
      return {
        'Kit Size': data.name
      };
    }

    async function addToCart() {
      if (booting || !addBtn) return;

      const data = selectedData();
      const variantId = findVariant(selected);

      if (!variantId) {
        alert('This kit size is not configured with a Shopify variant ID.');
        return;
      }

      booting = true;
      const oldText = addBtn.textContent;
      addBtn.disabled = true;
      addBtn.textContent = 'Adding...';

      try {
        if (window.CaraKitOrderGift && typeof window.CaraKitOrderGift.save === 'function') {
          await window.CaraKitOrderGift.save();
        }

        const response = await fetch(getShopifyRoot() + 'cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          },
          body: JSON.stringify({
            items: [{
              id: Number(variantId),
              quantity: Number(quantity),
              properties: getProperties(data)
            }],
            sections: [
              'cart-drawer',
              'cart-icon-bubble',
              'header'
            ],
            sections_url: window.location.pathname + window.location.search
          })
        });

        const result = await response.json();

        if (!response.ok) {
          throw new Error(result.description || result.message || 'Cart request failed');
        }

        const detail = { cart: result, items: result.items || [] };

        document.dispatchEvent(new CustomEvent('cart:updated', { detail: detail, bubbles: true }));
        document.dispatchEvent(new CustomEvent('cart:refresh', { detail: detail, bubbles: true }));
        document.dispatchEvent(new CustomEvent('cart:build', { detail: detail, bubbles: true }));
        document.dispatchEvent(new CustomEvent('cart:change', { detail: detail, bubbles: true }));
        document.dispatchEvent(new CustomEvent('ajaxProduct:added', { detail: detail, bubbles: true }));

        if (window.theme && window.theme.cart && typeof window.theme.cart.getCart === 'function') {
          try { window.theme.cart.getCart(); } catch (e) {}
        }

        setTimeout(openCartDrawer, 150);

      } catch (error) {
        console.error('CaraKit cart error:', error);
        alert(error.message || 'Could not add this kit to cart.');
      } finally {
        addBtn.disabled = false;
        addBtn.textContent = 'Add to Cart — ' + money(data.price * quantity);
        booting = false;
      }
    }

    function render() {
      const data = selectedData();
      if (!data) return;

      renderSizeCards();
      renderGallery(data);
      renderMainData(data);
      renderItems(data);
      renderComparison();
      renderExclusive(data);
      renderWhyChoose(data);
      renderInstruction(data);
      syncQuantityUI();
    }

    const qtyMinus = query('[data-qty-minus]');
    const qtyPlus = query('[data-qty-plus]');

    if (qtyMinus) {
      qtyMinus.addEventListener('click', function () {
        quantity = Math.max(1, quantity - 1);
        render();
      });
    }

    if (qtyPlus) {
      qtyPlus.addEventListener('click', function () {
        quantity += 1;
        render();
      });
    }

    if (addBtn) {
      addBtn.addEventListener('click', function (event) {
        event.preventDefault();
        addToCart();
      });
    }

    if (accordionButton) {
      accordionButton.addEventListener('click', function () {
        expanded = !expanded;
        renderItems(selectedData());
      });
    }

    // Gift Container Toggle
    if (giftToggle && giftFields) {
      const toggleFields = () => {
        giftFields.style.display = giftToggle.checked ? 'block' : 'none';
      };
      toggleFields();
      giftToggle.addEventListener('change', toggleFields);
    }

    // Company vs Personal Fields Toggle
    if (companyToggle && standardFromBlock && companyFieldsBlock) {
      const toggleCompanyFields = () => {
        if (companyToggle.checked) {
          standardFromBlock.style.display = 'none';
          companyFieldsBlock.style.display = 'block';
        } else {
          standardFromBlock.style.display = 'block';
          companyFieldsBlock.style.display = 'none';
        }
      };
      toggleCompanyFields();
      companyToggle.addEventListener('change', toggleCompanyFields);
    }

    // Word Count Counter
    if (giftMessageArea && giftWordCount) {
      giftMessageArea.addEventListener('input', function () {
        const text = giftMessageArea.value.trim();
        const words = text ? text.split(/\s+/).length : 0;
        giftWordCount.textContent = words + '/150 words';
      });
    }

    window.addEventListener('popstate', function () {
      params = new URLSearchParams(window.location.search);
      const nextSize = params.get('size');
      selected = ALLOWED_SIZES.includes(nextSize) ? nextSize : 'medium';
      galleryIndex = 0;
      render();
    });

    document.addEventListener('shopify:section:load', function (event) {
      if (event.target && event.target.id === 'CaraKitChemotherapy-' + sectionId) {
        render();
      }
    });

    render();
  }

  function init() {
    const sections = window.CaraKitChemotherapy || {};
    Object.keys(sections).forEach(boot);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();